/**
 * フッターリンクの設定
 */
const startYear = 2019
const currentYear = (new Date()).getFullYear()
const yearRange = startYear.toString() + (startYear !== currentYear ? '-' + currentYear.toString() : '')
export const footer = {
  links: [
    {
      label: 'ご利用にあたって',
      url: 'https://www.neo.co.jp/terms.html'
    },
    {
      label: '個人情報保護方針',
      url: {name: 'copyright'} // objectの場合、router-linkを使う
    },
    {
      label: 'グループウェア desknet\'s NEO',
      url: 'https://www.desknets.com/'
    },
    {
      label: '株式会社ネオジャパン',
      url: 'https://www.neo.co.jp/'
    }
  ],
  copyrightHtml: `Copyright &copy;${yearRange} NEOJAPAN Inc. All Rights Reserved.`
}

/**
 * ご利用ガイドURL
 */
export const guideUrl = 'https://www.desknets.com/sales/pdf/application_form.pdf'



// WEBPACK FOOTER //
// ./src/data/config.js